import React, { FC } from 'react'
import { Badge } from '@wmgtech/legato'
import styles from '../Story.module.scss'

type TNewBadgeProps = {
  isVisible?: boolean
}

export const NewBadge: FC<TNewBadgeProps> = (props) => {

  return props.isVisible ? (
    <Badge
      size={'xs'}
      rounded
      text={'NEW'}
      containerStyle={'solid'}
      className={styles.newBadge}
    />
  ) : null
}
